// extracted by mini-css-extract-plugin
module.exports = {"colorblue":"#078ada","colorcompleted":"#81c784","colornotcompleted":"#ef5350","colorgrey80":"#ccc"};